import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { FontSizeContext } from "../../context/fontSizeContext";

const AnnualReportContainer = ({ contRef }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    // Files in the public folder are served from the root URL "/"
    useEffect(() => {
        fetch("../../data/annual-report.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch JSON");
                }
                return response.json();
            })
            .then((jsonData) => {
                setData(jsonData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error loading JSON:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        // <div className="single-service pb-0 pt-10 " ref={contRef}>
        //     <div className="container">
        //         <div className="row justify-content-center">
        //             {data.map((single, i) => {
        //                 if (single.id != 9) {
        //                     return (
        //                         <div
        //                             className="col-xl-4 col-lg-3 col-sm-6 mb-5"
        //                             key={i}
        //                         >
        //                             <div className="sidbar-menu align-items-center pdf-div">
        //                                 <ul>
        //                                     <li>
        //                                         <NavLink
        //                                             target="_blank"
        //                                             activeClassName="active"
        //                                             className="padding-15 pdf-div-trans "
        //                                             to={
        //                                                 process.env
        //                                                     .PUBLIC_URL +
        //                                                 single.link
        //                                             }
        //                                         >
        //                                             <i
        //                                                 className="fa fa-download px-2"
        //                                                 role="img"
        //                                                 aria-label="Download "
        //                                             >
        //                                                 &nbsp;&nbsp;
        //                                             </i>
        //                                             <p
        //                                                 className="font-14 justify-content-center"
        //                                                 ref={(el) =>
        //                                                     (textRefs.current[
        //                                                         i
        //                                                     ] = el)
        //                                                 }
        //                                             >
        //                                                 {single.name}
        //                                             </p>
        //                                         </NavLink>
        //                                     </li>
        //                                 </ul>
        //                             </div>
        //                         </div>
        //                     );
        //                 } else {
        //                     return (
        //                         <div key={i}>
        //                             <div
        //                                 className="row justify-content-center item-mobile"
        //                                 key={i}
        //                             >
        //                                 <div
        //                                     className="col-xl-4 col-lg-3 col-sm-6 mb-5 "
        //                                     key={i}
        //                                 >
        //                                     <div className="sidbar-menu align-items-center pdf-div-highlight">
        //                                         <ul>
        //                                             <li>
        //                                                 <NavLink
        //                                                     target="_blank"
        //                                                     activeClassName="active"
        //                                                     className="padding-15 pdf-div-trans-highlight "
        //                                                     to={
        //                                                         process.env
        //                                                             .PUBLIC_URL +
        //                                                         single.link
        //                                                     }
        //                                                 >
        //                                                     <i className="fa fa-download px-2">
        //                                                         &nbsp;&nbsp;
        //                                                     </i>
        //                                                     <p
        //                                                         className="font-14 justify-content-center"
        //                                                         ref={(el) =>
        //                                                             (textRefs.current[
        //                                                                 i
        //                                                             ] = el)
        //                                                         }
        //                                                     >
        //                                                         {
        //                                                             single.name
        //                                                         }
        //                                                     </p>
        //                                                 </NavLink>
        //                                             </li>
        //                                         </ul>
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             <div className="sidbar-menu align-items-center item-desk mb-8">
        //                                 <ul className="pdf-div-highlight ">
        //                                     <li>
        //                                         <NavLink
        //                                             target="_blank"
        //                                             activeClassName="active"
        //                                             className="padding-15 pdf-div-trans "
        //                                             to={
        //                                                 process.env
        //                                                     .PUBLIC_URL +
        //                                                 single.link
        //                                             }
        //                                         >
        //                                             <i className="fa fa-download px-2">
        //                                                 &nbsp;&nbsp;
        //                                             </i>
        //                                             <p
        //                                                 className="font-14 justify-content-center"
        //                                                 ref={(el) =>
        //                                                     (textRefs.current[
        //                                                         i
        //                                                     ] = el)
        //                                                 }
        //                                             >
        //                                                 {single.name}
        //                                             </p>
        //                                         </NavLink>
        //                                     </li>
        //                                 </ul>
        //                             </div>
        //                         </div>
        //                     );
        //                 }
        //             })}
        //         </div>
        //     </div>
        // </div>

        <div className="single-service pb-0 pt-10" ref={contRef}>
            <div className="container">
                {/* ✅ SINGLE UL */}
                <ul className="row justify-content-center list-unstyled m-0 p-0">
                    {data.map((single, i) => {
                        if (single.id !== 9) {
                            return (
                                <li
                                    key={i}
                                    className="col-xl-4 col-lg-3 col-sm-6 mb-5"
                                >
                                    <div className="sidbar-menu align-items-center pdf-div">
                                        <NavLink
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            activeClassName="active"
                                            className="padding-15 pdf-div-trans d-flex align-items-center justify-content-center"
                                            to={
                                                process.env.PUBLIC_URL +
                                                single.link
                                            }
                                        >
                                            <i
                                                className="fa fa-download px-2 text-dark fw-semibold"
                                                role="img"
                                                aria-label="Download"
                                            />

                                            <p
                                                className="font-14 mb-0 text-dark"
                                                style={{
                                                    fontFamily:
                                                        "Open Sans,sans-serif",
                                                    fontWeight: "600",
                                                }}
                                                ref={(el) =>
                                                    (textRefs.current[i] = el)
                                                }
                                            >
                                                {single.name}
                                            </p>
                                        </NavLink>
                                    </div>
                                </li>
                            );
                        }

                        // ✅ SPECIAL CASE (id === 9)
                        return (
                            <li key={i} className="w-100">
                                {/* Mobile View */}
                                <div className="row justify-content-center item-mobile">
                                    <div className="col-xl-4 col-lg-3 col-sm-6 mb-5">
                                        <div className="sidbar-menu align-items-center pdf-div-highlight">
                                            <NavLink
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                activeClassName="active"
                                                className="padding-15 pdf-div-trans-highlight d-flex align-items-center justify-content-center"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    single.link
                                                }
                                            >
                                                <i className="fa fa-download px-2 fw-semibold" />

                                                <p
                                                    className="font-14 mb-0"
                                                    style={{
                                                        fontFamily:
                                                            "Open Sans,sans-serif",
                                                        fontWeight: "600",
                                                    }}
                                                    ref={(el) =>
                                                        (textRefs.current[i] =
                                                            el)
                                                    }
                                                >
                                                    {single.name}
                                                </p>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>

                                {/* Desktop View */}
                                <div className="sidbar-menu align-items-center item-desk mb-8">
                                    <NavLink
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        activeClassName="active"
                                        className="padding-15 pdf-div-trans d-flex align-items-center pdf-div-highlight justify-content-center"
                                        to={
                                            process.env.PUBLIC_URL + single.link
                                        }
                                    >
                                        <i className="fa fa-download px-2 text-dark fw-semibold" />

                                        <p
                                            className="font-14 mb-0 text-dark"
                                            style={{
                                                fontFamily:
                                                    "Open Sans,sans-serif",
                                                fontWeight: "600",
                                            }}
                                            ref={(el) =>
                                                (textRefs.current[i] = el)
                                            }
                                        >
                                            {single.name}
                                        </p>
                                    </NavLink>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

AnnualReportContainer.propTypes = {
    data: PropTypes.array,
    contRef: PropTypes.any,
};

export default AnnualReportContainer;
